import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=5eaeb7ff&scoped=true&"
import script from "./Instagram.vue?vue&type=script&lang=js&"
export * from "./Instagram.vue?vue&type=script&lang=js&"
import style1 from "./Instagram.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaeb7ff",
  null
  
)

export default component.exports